import { render, staticRenderFns } from "./DownloadableFileList.vue?vue&type=template&id=2cf15862&"
import script from "./DownloadableFileList.vue?vue&type=script&lang=js&"
export * from "./DownloadableFileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports